/**
 * JULEPS PRODUCT HERO - JavaScript
 * Gestion ajout au panier + quantité + line item properties + "Lire plus"
 */

if (!customElements.get('juleps-product-hero')) {
  class JulepsProductHero {
    constructor() {
      this.init();
    }

    init() {
      // Attendre que le DOM soit chargé
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      const form = document.querySelector('[data-product-form]');
      if (!form) return;

      // Gestion de la quantité
      this.setupQuantityControls(form);

      // Gestion du formulaire d'ajout au panier
      this.setupAddToCart(form);
    }

    setupQuantityControls(form) {
      const minusBtn = form.querySelector('[data-quantity-minus]');
      const plusBtn = form.querySelector('[data-quantity-plus]');
      const input = form.querySelector('[data-quantity-input]');

      if (!input) return;

      // Bouton -
      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > 1) {
            input.value = currentValue - 1;
            this.updateMinusButtonState(minusBtn, input.value);
          }
        });
      }

      // Bouton +
      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          input.value = currentValue + 1;
          this.updateMinusButtonState(minusBtn, input.value);
        });
      }

      // Input direct
      input.addEventListener('change', () => {
        const value = parseInt(input.value) || 1;
        if (value < 1) input.value = 1;
        this.updateMinusButtonState(minusBtn, input.value);
      });

      // État initial du bouton -
      this.updateMinusButtonState(minusBtn, input.value);
    }

    updateMinusButtonState(btn, value) {
      if (!btn) return;
      if (parseInt(value) <= 1) {
        btn.classList.add('juleps-product-hero__quantity-btn--disabled');
      } else {
        btn.classList.remove('juleps-product-hero__quantity-btn--disabled');
      }
    }

    setupAddToCart(form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const submitBtn = form.querySelector('.juleps-product-hero__add-to-cart');
        if (submitBtn.disabled) return;

        // Désactiver le bouton pendant la requête
        submitBtn.disabled = true;
        const originalHTML = submitBtn.innerHTML;
        submitBtn.innerHTML = '<span style="font-size: 12px;">...</span>';

        try {
          // Préparer les données du formulaire
          const formData = new FormData(form);
          
          // Récupérer l'ID de la variante
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity')) || 1;

          // Récupérer les properties (dont _prochaine_livraison)
          const properties = {};
          for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              const propertyKey = key.match(/properties\[(.*?)\]/)[1];
              properties[propertyKey] = value;
            }
          }

          // Ajouter au panier via l'API Shopify
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              properties: properties
            })
          });

          if (!response.ok) {
            throw new Error('Erreur lors de l\'ajout au panier');
          }

          const item = await response.json();

          // Succès : mettre à jour le compteur du panier
          this.updateCartCount();

          // Feedback visuel
          submitBtn.innerHTML = '✓';
          setTimeout(() => {
            submitBtn.innerHTML = originalHTML;
            submitBtn.disabled = false;
          }, 1500);

          // Optionnel : ouvrir le drawer panier (si vous en avez un)
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { item }
          }));

        } catch (error) {
          console.error('Erreur ajout au panier:', error);
          alert('Une erreur est survenue. Veuillez réessayer.');
          submitBtn.innerHTML = originalHTML;
          submitBtn.disabled = false;
        }
      });
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Mettre à jour le badge du header (si existe)
        const cartBadges = document.querySelectorAll('.juleps-header__cart-badge');
        cartBadges.forEach(badge => {
          badge.textContent = cart.item_count;
          if (cart.item_count > 0) {
            badge.style.display = 'block';
          }
        });
      } catch (error) {
        console.error('Erreur lors de la mise à jour du compteur panier:', error);
      }
    }
  }

  // Initialiser au chargement
  new JulepsProductHero();
}

